/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_What_PlaceholderInputs */

const en_directory_search_what_placeholder = /** @type {(inputs: Directory_Search_What_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service or what hurts`)
};

const pl_directory_search_what_placeholder = /** @type {(inputs: Directory_Search_What_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usługa lub co boli`)
};

/**
* | output |
* | --- |
* | "Service or what hurts" |
*
* @param {Directory_Search_What_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_search_what_placeholder = /** @type {((inputs?: Directory_Search_What_PlaceholderInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_What_PlaceholderInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_search_what_placeholder(inputs)
	return en_directory_search_what_placeholder(inputs)
});